<template>
  <!--
            作者：luoyiming
            时间：2020-04-20
            描述：修改价格
        -->
  <el-dialog title="审核订单" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" width="30%">
    <!-- <el-radio v-model="radio" :label="1">通过</el-radio> -->
    <el-radio v-model="radio" :label="0">驳回</el-radio>
    <el-input v-model="input" placeholder="请输入备注信息" style="margin-top:10px;"></el-input>
    <el-input v-model="password" placeholder="请输入密码" type="password" style="margin-top: 10px;" />
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitFunc()" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import OrderApi from '@/api/order.js';
export default {
  data() {
    return {
      input: "",
      order_id: 0,
      loading: false,
      shneheList: [],
      /*左边长度*/
      formLabelWidth: '100px',
      /*是否显示*/
      dialogVisible: true,
      /*表单*/
      // order: {
      //     update_price: 0,
      //     update_express_price: 0.00,
      // },
      radio: 0,
      status: '',
      password: ""
    };
  },
  props: ['open_edit', 'order', 'order_id'],
  created() {
    this.order_id = this.order_id;
    // this.shneheList = this.order;
    // console.log(this.shneheList,"看看")
  },
  methods: {
    // 获取数据
    submitFunc() {
      let self = this;
      OrderApi.checkpwd2({
        password: self.password
      }).then(res => {
        if (res.code == 1) {
          if (this.radio == 1) {
            this.status = 2;
          } else {
            this.status = 20;
          }
          OrderApi.toExamine1({
            order_id: this.order_id,
            // billid:this.shneheList,
            type: this.radio,
            status: this.status,
            tips: this.input
          }, true).then(data => {
            self.loading = false;
            self.$message({
              message: '修改成功',
              type: 'success'
            });
            self.dialogFormVisible(true);

          }).catch(error => {
            self.loading = false;
          });
        }
      })

    },
    /*确认事件*/
    // submitFunc(e) {
    //     let self = this;
    //     let order = this.order;
    //     self.loading = true;
    //     OrderApi.updatePrice({
    //         order_id: this.order_id,
    //         order: order,
    //     }, true).then(data =>
    //     {
    //         self.loading = false;
    //         self.$message({
    //             message: '修改成功',
    //             type: 'success'
    //         });
    //         self.dialogFormVisible(true);
    //     }).catch(error =>
    //     {
    //         self.loading = false;
    //     });
    // },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('close', { openDialog: false });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Ju.vue